/**
 *   Created by Arif Topcu in 2018
 */
import React from 'react';
import PropTypes from 'prop-types';
import Switch from '@ls/react-switch';

const LookThruSwitch = ({checked, onChange}) => (
  <Switch
    label="Lookthru"
    value={checked}
    onChange={onChange}
    raised
  />
);

LookThruSwitch.propsTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default LookThruSwitch;
